
export const projectArray = [
    {
        id:0,
        title: 'Ecosystem Restoration',
        image: '../img/Projects/EcoR-1.jpg',
        url: '/Ecosystem-Restoration'
    },

    {
        id:1,
        title: 'Environmental Education',
        image: '../img/Projects/WED24-1.jpg',
        url: '/Environmental-Education'
    },

    {
        id:2,
        title: 'Community Engagement',
        image: '../img/Projects/eb-8.jpg',
        url: '/CommunityEngagement'
    },

    {
        id:3,
        title: 'Nature Lab Project',
        image: '../img/Projects/NLP-1.jpg',
        url: '/Nature-Lab-Project'
    },

    {
        id:4,
        title: 'Green Hangout',
        image: '../img/Projects/gh.jpg',
        url: '/Projects/GreenHangout'
    },

    {
        id:5,
        title: 'Climate Bootcamp',
        image: '../img/Projects/CB-2024-5.jpg',
        url: '/Climate-Bootcamp'
    },

    {
        id:6,
        title: 'Youth Climate Policy Training',
        image: '../img/Projects/ycpt-2.jpg',
        url: '/Projects/YouthClimatePolicy'
    }
];

export const sideBarProjectArray = [
    {
        id:0,
        title: 'Anambra Climate Bootcamp 2025',
        image: '../img/InternationalDayOfForests/IDF 2.jpg',
        url: '../Projects/ClimateBootcamp-2025',
    },

    {
        id:1,
        title: 'Anambra Climate Bootcamp 2024',
        image: '../img/InternationalDayOfForests/IDF 2.jpg',
        url: '../Projects/ClimateBootcamp-2024',
    },

    {
        id:2,
        title: 'Anambra Climate Bootcamp 2023',
        image: '../img/InternationalDayOfForests/IDF 2.jpg',
        url: '../Projects/ClimateBootcamp-2023',
    },


    {
        id:3,
        title: 'Agriculture Empowerment Programme',
        image: '../img/InternationalDayOfForests/IDF 2.jpg',
        url: '../Projects/Ebenebe-Agriculture-Empowerment-Programme',
    },

    {
        id:4,
        title: 'Climate Resiliance Workshop',
        image: '../img/Ebenebe/eb-2.jpg',
        url: '../Projects/Ebenebe-Climate-Resilience-Workshop',
    },

    {
        id:5,
        title: 'Community Engagement',
        image: '../img/NLP/NLP-2.jpg',
        url: '../Projects/Ebenebe-Community-Engagement',
    },

    {
        id:6,
        title: 'Green Hangout',
        image: '../img/GreenHangout/project-2.jpg',
        url: '/Projects/GreenHangout',
    },


    {
        id:7,
        title: 'Youth Climate Policy Training 2024',
        image: '../img/YCPT/ycpt.jpg',
        url: '../Projects/YouthClimatePolicy',
    },

    {
        id:8,
        title: 'Tree Nursery Project',
        image: '../img/NLP/NLP-2.jpg',
        url: '../Projects/Tree-Nursery-project',
    },

    {
        id:9,
        title: 'Tree Planting Project',
        image: '../img/GreenHangout/project-2.jpg',
        url: '../Projects/Tree-planting-project',
    },

    {
        id:10,
        title: 'World Earth Day 2024',
        image: '../img/NLP/NLP-2.jpg',
        url: '../Projects/WorldEarthDay-2024',
    },

    {
        id:11,
        title: 'World Environment Day 2024',
        image: '../img/GreenHangout/project-2.jpg',
        url: '../Projects/WorldEnvironmentDay-2024',
    },

    {
        id:12,
        title: 'World Forest Day 2022',
        image: '../img/GreenHangout/project-2.jpg',
        url: '../Projects/WorldForestDay-2022',
    },

];

export const climateBootcampArray = [
    {
        id:0,
        title: 'Anambra Climate Bootcamp 2023',
        image: '../img/Projects/acb-19.jpg',
        url: '../Projects/ClimateBootcamp-2023',
        date: ' 26th/July/2023',
        description: 'At Green Environment and Climate change Initiative (GRENCHI), we believe that taking action to address climate change is crucial for a sustainable future. Our Climate BootCamp is an immersive program'
    },

    {
        id:1,
        title: 'Anambra Climate Bootcamp 2024',
        image: '../img/Projects/CB-2024-5.jpg',
        url: '../Projects/ClimateBootcamp-2024',
        date: ' 24th/July/2024',
        description: 'This event aimed to inspire and equip young environmental leaders with practical knowledge and skills to drive environmental actions. The bootcamp empowered students to participate actively in environmental conservation and '
    },
    
];

export const communityEngagementArray = [
    {
        id:0,
        title: 'Climate Resiliance Workshop',
        image: '../img/Projects/eb-8.jpg',
        url: '../Projects/Ebenebe-Climate-Resilience-Workshop',
        date:'16th/Jan/2024',
        description: 'Green Environment and Climate Change Initiative (GRENCHI), with the unwavering support of the Nigeria Climate Justice Alliance (NCJA), Nigeria Conservation Foundation (NCF), and in partnership with the Department of Forestry and Wildlife,'
    },

    {
        id:1,
        title: 'Agriculture Empowerment Programme',
        image: '../img/Projects/EAEP-2.jpg',
        url: '../Projects/Ebenebe-Agriculture-Empowerment-Programme',
        date:'16th/Jan/2024',
        description: 'In our ongoing effort to bolster the resilience of the Ebenebe Community in Awka North Local Government Area, Anambra State, Nigeria, we recently conducted an Agriculture Empowerment Programme for twenty (20) farmers within the community.'
    },


    {
        id:3,
        title: 'Community Engagement',
        image: '../img/Projects/ECE-2.jpg',
        url: '../Projects/Ebenebe-Community-Engagement',
        date:'16th/Jan/2024',
        description: 'Recognizing these challenges, our organization has initiated a comprehensive community development project aimed at building resilience against climate change and preventing deforestation. Our goal is to empower '
    },
]

export const environmentalEducationArray = [
    {
        id:1,
        title: 'World Earth Day',
        image: '../img/Projects/WED24-5.jpg',
        url: '../Projects/WorldEarthDay-2024',
        description: 'As we mark Earth Day 2024, the global theme "Planet vs. Plastics" starkly reminds us of the urgent need to address the environmental and health crises posed by plastic pollution.'
    },

    {
        id:2,
        title: 'World Environment Day',
        image: '../img/Projects/EnvironmentDay.jpg',
        url: '../Projects/WorldEnvironmentDay-2024',
        description: 'As we mark the World Environment Day today, June 5th, 2024, the focus is on the critical issues of land restoration, desertification, and drought.'
    },

    {
        id:3,
        title: 'World Forestry Day',
        image: '../img/Projects/idf.jpg',
        url: '../Projects/WorldForestDay-2022',
        description: 'In commemoration of IDF, Green Environment and Climate Change Initiative (GRENCHI) in collaboration with the Department of Forestry and Wildlife, Ministry of Environment'
    },
]

export const natureLabProjectArray = [
    {
        id:1,
        title: 'Tree Nursery Project',
        image: '../img/Projects/NLP-1.jpg',
        url: '../Projects/Tree-Nursery-project',
    },

    {
        id:2,
        title: 'Tree Planting Project',
        image: '../img/Projects/Tree-planting.jpg',
        url: '../Projects/Tree-planting-project',
    },
]

export const blogArray = [
    {
        id:0,
        title: 'The Concept of Environmental Education',
        image: '../img/Blog/CCE-sq.jpg',
        url: '../Blog/Concept-of-Environmental-Education',
        snippet: 'In a world facing unprecedented environmental challenges such as climate change, land degradation, pollution, erosion, deforestation, biodiversity loss, etc., it has become increasingly crucial to equip the next generation with the knowledge and skills needed to tackle these issues. This is where environmental education '
    },

    {
        id:1,
        title: 'The Role of Community Engagement in Environmental Education',
        image: '../img/Blog/EE.jpeg',
        url: '../Blog/The-Role-of-Community-Engagement-in-Environmental-Education',
        snippet: 'Ecosystem restoration is a crucial effort aimed at reversing the damage inflicted on our natural environments. For these efforts to be truly successful and sustainable, community engagement must be at the forefront. Understanding and integrating the social aspects of restoration can significantly enhance the effectiveness and longevity of these projects.'
    },

    {
        id:2,
        title: 'Give to gain — A Thought Reflection on Women, the Earth, and the Power of Giving',
        image: '../img/Blog/forest.png',
        url: '../Blog/Give-to-gain-A-Thought-Reflection-on-Women',
        Date: '8th/March/2026',
        snippet: 'Today, on this eve of International Women’s Day, GRENCHI pauses to reflect — not with fanfare, but with deep reverence — on the women who have always understood, in their bones and in their hands, what it means to give so that others may gain.'
    }
]

export const eventsArray = [
    {
        id:1,
        title: 'GECCI Youth Policy Training',
        image: '../img/Events/event-youth-policy.jpg',
        url: '../Events/Youth-Policy-Training',
        date: '09/02/2024 - 10/02/2024'
    },

    {
        id:2,
        title: 'Environmental-STEM mini-grant',
        image: '../img/Events/Bootcamp1.jpg',
        url: '../Events/Environmental-STEM-mini-grant-application',
        date: '24/07/2024'
    },

    {
        id:3,
        title: 'Climate Bootcamp 3.0',
        image: '../img/Events/Bootcamp-3.png',
        url: '../Events/Climate-Bootcamp-3-0',
        date: 'TBD/07/2025'
    }
]

export default projectArray;